var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIbk30(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.9124 1.66297C7.17286 2.03224 6.62193 2.66757 6.36156 3.4519L1.41032 18.3323C1.14797 19.1142 1.20935 19.9557 1.58159 20.6984C1.95161 21.4328 2.58743 21.9852 3.36904 22.2466L19.6063 27.698C20.3936 27.9593 21.2341 27.8997 21.9726 27.5289C22.7119 27.1555 23.2641 26.5236 23.5212 25.737L28.4747 10.8611C29.017 9.24068 28.1351 7.48244 26.5147 6.94264L10.279 1.49269C9.49021 1.23257 8.65514 1.28925 7.9124 1.66297Z",
    fill: "#FEFEFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.2168 18.9326H9.33574V11.2027H8.2168V18.9326ZM15.8492 15.9539C14.9674 16.938 13.8678 17.732 12.5931 18.2243L11.8603 18.5081V11.6138L12.5842 11.8942C13.8606 12.3815 14.9629 13.1757 15.8492 14.1551C16.4801 13.1399 16.8719 11.962 16.9523 10.6809C17.1528 7.37583 15.0827 4.34297 12.2392 3.28738L9.89339 2.50676C8.83484 2.15408 7.70797 2.73793 7.35875 3.79352L2.3934 18.6824C2.04071 19.7422 2.63471 20.8918 3.69451 21.2403L14.9629 25.0025C16.1118 23.7809 16.8571 22.1622 16.966 20.3567C17.0655 18.7457 16.6454 17.2268 15.8492 15.9539Z",
    fill: "#198FCA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.199 15.0544C14.5698 14.3168 13.8093 13.6971 12.9312 13.2432V16.8765C13.8093 16.4216 14.5741 15.7944 15.199 15.0544Z",
    fill: "#E95705"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4146 18.908L22.0177 18.912L19.144 15.0463L22.063 11.1818L23.472 11.1763L20.5463 15.0519L23.4146 18.908ZM26.154 7.93582L15.813 4.47998C17.202 6.00037 18.0519 8.02047 18.0558 10.2329C18.0581 11.9817 17.5128 13.6546 16.5639 15.0547C17.5163 16.4506 18.0647 18.1222 18.0694 19.871C18.0702 21.9599 17.3195 23.8845 16.0696 25.3747L19.9532 26.6708C21.0152 27.024 22.1364 26.4402 22.4895 25.3814L27.4574 10.494C27.8091 9.43592 27.2146 8.28727 26.154 7.93582Z",
    fill: "#015198"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIbk30);
export default __webpack_public_path__ + "static/media/IBK투자증권-30.9054f7f6dd7eab83a0cb752a974ec56d.svg";
export { ForwardRef as ReactComponent };